import React, { useEffect } from "react";
import "../companyMaster/companyMaster.scss";
import "react-datepicker/dist/react-datepicker.css";
import AddNewContactModal from "../../components/companyMaster/AddNewContactModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import CompanyDocuments from "../../components/companyMaster/CompanyDocuments";
import CompanyDetails from "../../components/companyMaster/CompanyDetails";
import AdditionalContact from "../../components/companyMaster/AdditionalContact";
import useForm from "./useForm";
import FetchData from "../../providers/dataProvider";
import { useLocation } from "react-router-dom";
import ErrorMessage from "../../components/common/ErrorMessage";

const AddNewCompany = () => {
  const location = useLocation();
  const {
    data: companydata,
    loading: companyLoading,
    error: companyError,
  } = FetchData("company");
  const {
    data: designationdata,
    loading: designationLoading,
    error: designationError,
  } = FetchData("designation");
  const {
    data: countrydata,
    loading: countryLoading,
    error: countryError,
  } = FetchData("country");
  const {
    data: departmentdata,
    loading: departmentLoading,
    error: departmentError,
  } = FetchData("department");
  const {
    data: currencydata,
    loading: currencyLoading,
    error: currencyError,
  } = FetchData("currency");

  const {
    HandleFormChange,
    formValues,
    setFormValues,
    country,
    HandleCountryChange,
    designation,
    HandleDesignationChange,
    HandleFormSubmit,
    HandleImageFileChange,
    formErrors,
    createMsg,
    show,
    setShow,
    setContactShow,
    contactShow,
    HandleContactChange,
    contacttemp,
    setContactTemp,
    HandleConDepChange,
    condepartment,
    HandleConDesChange,
    condesignation,
    HandleContactSubmit,
    contact,
    DeleteContact,
    EditContact,
    setConDesignation,
    setConDepartment,
    contactError,
    DeleteImage,
    ClearFormValues,
    setCountry,
    setDesignation,
    currency,
    setCurrency,
    HandleCurrencyChange,
    SuccessDoneClick,
    ErrorDoneClick,
    errorShow,
    showImage,
    contactClose,
    disabledSubmit,
    setFormError,
    setContactError
  } = useForm(designationdata, companydata, currencydata);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("pathfinderHeaderMetaChange", {
        detail: {
          pathname: location.pathname,
          title: formValues?.id
            ? `Company : ${formValues?.companyName}`
            : "New Company",
          backTarget: {
            pathname: "/company-master",
          },
        },
      })
    );

    return () => {
      window.dispatchEvent(
        new CustomEvent("pathfinderHeaderMetaChange", {
          detail: {
            pathname: location.pathname,
            clear: true,
          },
        })
      );
    };
  }, [
    location.pathname,
    formValues?.id,
    formValues?.companyName,
  ]);

  return (
    <div className="container-fluid add-new-company-sec">
      <section className="company-add-sec">
        <div className="row m-0">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0">
            {/* <!-- Company Details--> */}
            <CompanyDetails
              HandleFormChange={HandleFormChange}
              HandleImageFileChange={HandleImageFileChange}
              formValues={formValues}
              countrydata={countrydata}
              currencydata={currencydata}
              designationdata={designationdata}
              currency={currency}
              setCurrency={setCurrency}
              HandleCurrencyChange={HandleCurrencyChange}
              formErrors={formErrors}
              HandleDesignationChange={HandleDesignationChange}
              HandleCountryChange={HandleCountryChange}
              country={country}
              designation={designation}
              setCountry={setCountry}
              setDesignation={setDesignation}
              ClearFormValues={ClearFormValues}
              setFormValues={setFormValues}
              setFormError={setFormError}
              setContactShow={setContactShow}
              setContactTemp={setContactTemp}
              contactShow={contactShow}
              HandleContactChange={HandleContactChange}
              contacttemp={contacttemp}
              HandleConDepChange={HandleConDepChange}
              condepartment={condepartment}
              HandleConDesChange={HandleConDesChange}
              condesignation={condesignation}
              HandleContactSubmit={HandleContactSubmit}
              contact={contact}
              DeleteContact={DeleteContact}
              EditContact={EditContact}
              setConDesignation={setConDesignation}
              setConDepartment={setConDepartment}
              contactError={contactError}
              DeleteImage={DeleteImage}
              showImage={showImage}
              contactClose={contactClose}
              setContactError={setContactError}
              HandleFormSubmit={HandleFormSubmit}
            />
          </div>
        </div>
      </section>

      {/*  <!-- addNewContactModal--> */}
      <AddNewContactModal
        setContactShow={setContactShow}
        contactShow={contactShow}
        HandleContactChange={HandleContactChange}
        contacttemp={contacttemp}
        setContactTemp={setContactTemp}
        departmentdata={departmentdata}
        designationdata={designationdata}
        HandleConDepChange={HandleConDepChange}
        condepartment={condepartment}
        HandleConDesChange={HandleConDesChange}
        condesignation={condesignation}
        HandleContactSubmit={HandleContactSubmit}
        setConDesignation={setConDesignation}
        setConDepartment={setConDepartment}
        contactError={contactError}
        contactClose={contactClose}
        setContactError={setContactError}
      />

      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />

      {/* <!-- saveSuccessModal--> */}
      <SaveSuccessModel
        show={show}
        createMsg={createMsg}
        setShow={setShow}
        SuccessDoneClick={SuccessDoneClick}
      />
    </div>
  );
};

export default AddNewCompany;